import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../shared/services/http-client/http-client.service';
import {
  ClonarInstitutoParamResgateCommandDto,
  CreateInstitutoParamResgateCommandDto,
  InstitutoParamResgateResponseDto,
  InstitutosParamResgateQueryParams,
  PatchInstitutoParamResgateCommandDto,
  ProvedorAssinaturaResponseDto,
  ProvedoresAssinaturaQueryParams,
} from '../../models/parametros/resgate-configuracao-api.model';

const INSTITUTOS_PARAM_RESGATE_BASE_PATH = '/v1/institutos-param-resgate';
const PROVEDORES_ASSINATURA_BASE_PATH = '/v1/provedores-assinatura';

@Injectable({
  providedIn: 'root',
})
export class ResgateConfiguracaoApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  listarResgates(params?: InstitutosParamResgateQueryParams): Observable<InstitutoParamResgateResponseDto[]> {
    return this.httpClient.get<InstitutoParamResgateResponseDto[]>(INSTITUTOS_PARAM_RESGATE_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  criarResgate(command: CreateInstitutoParamResgateCommandDto): Observable<InstitutoParamResgateResponseDto> {
    return this.httpClient.post<InstitutoParamResgateResponseDto>(INSTITUTOS_PARAM_RESGATE_BASE_PATH, command);
  }

  atualizarResgate(
    id: number,
    command: PatchInstitutoParamResgateCommandDto,
  ): Observable<InstitutoParamResgateResponseDto> {
    return this.httpClient.patch<InstitutoParamResgateResponseDto>(
      `${INSTITUTOS_PARAM_RESGATE_BASE_PATH}/${id}`,
      command,
    );
  }

  clonarResgate(
    id: number,
    command: ClonarInstitutoParamResgateCommandDto,
  ): Observable<InstitutoParamResgateResponseDto> {
    return this.httpClient.post<InstitutoParamResgateResponseDto>(
      `${INSTITUTOS_PARAM_RESGATE_BASE_PATH}/${id}/clonar`,
      command,
    );
  }

  listarProvedoresAssinatura(params?: ProvedoresAssinaturaQueryParams): Observable<ProvedorAssinaturaResponseDto[]> {
    return this.httpClient.get<ProvedorAssinaturaResponseDto[]>(PROVEDORES_ASSINATURA_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  private toHttpParams(
    params?: InstitutosParamResgateQueryParams | ProvedoresAssinaturaQueryParams,
  ): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    for (const [chave, valor] of Object.entries(params)) {
      if (valor != null && valor !== '') {
        httpParams = httpParams.set(chave, String(valor));
      }
    }

    return httpParams.keys().length > 0 ? httpParams : undefined;
  }
}
